import React from "react"

const Comparison = (
  props: React.SVGProps<SVGSVGElement> & { color?: string },
) => {
  const { color, ...rest } = props
  return (
    <svg
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.46105 1.11658C7.94341 1.11658 7.51988 1.54011 7.51988 2.05775V15.2342C7.51988 15.7519 7.94341 16.1754 8.46105 16.1754C8.9787 16.1754 9.40223 15.7519 9.40223 15.2342V2.05775C9.40223 1.54011 8.9787 1.11658 8.46105 1.11658ZM5.63752 3.94011H1.87282C1.35517 3.94011 0.931641 4.36364 0.931641 4.88128V6.76364C0.931641 7.28128 1.35517 7.70481 1.87282 7.70481H5.63752C6.15517 7.70481 6.5787 7.28128 6.5787 6.76364V4.88128C6.5787 4.36364 6.15517 3.94011 5.63752 3.94011ZM15.0493 3.94011H11.2846C10.7669 3.94011 10.3434 4.36364 10.3434 4.88128V6.76364C10.3434 7.28128 10.7669 7.70481 11.2846 7.70481H15.0493C15.5669 7.70481 15.9905 7.28128 15.9905 6.76364V4.88128C15.9905 4.36364 15.5669 3.94011 15.0493 3.94011ZM15.0493 6.76364H11.2846V4.88128H15.0493V6.76364ZM15.0493 9.58717H11.2846C10.7669 9.58717 10.3434 10.0107 10.3434 10.5283V12.4107C10.3434 12.9283 10.7669 13.3519 11.2846 13.3519H15.0493C15.5669 13.3519 15.9905 12.9283 15.9905 12.4107V10.5283C15.9905 10.0107 15.5669 9.58717 15.0493 9.58717ZM15.0493 12.4107H11.2846V10.5283H15.0493V12.4107ZM5.63752 9.58717H1.87282C1.35517 9.58717 0.931641 10.0107 0.931641 10.5283V12.4107C0.931641 12.9283 1.35517 13.3519 1.87282 13.3519H5.63752C6.15517 13.3519 6.5787 12.9283 6.5787 12.4107V10.5283C6.5787 10.0107 6.15517 9.58717 5.63752 9.58717Z"
        fill={color || "var(--midnight)"}
      />
    </svg>
  )
}

export default Comparison
